import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_routing_overview_return_other",
  ref: "orderRoutingReturnOtherModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-1000px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header",
  id: "kt_modal_routing_overview_return_header"
}
const _hoisted_5 = { class: "w-100 d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "modal-body p-0" }
const _hoisted_12 = { class: "modal-footer flex-right" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "indicator-label" }
const _hoisted_15 = { class: "svg-icon svg-icon-3 me-2 ms-0" }
const _hoisted_16 = { class: "indicator-progress" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_order_tracking_icon = _resolveComponent("order-tracking-icon")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.t("orderAssign.toBeReturned")), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_form, {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.formData,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_el_form_item, { prop: "ids" }, null, 512), [
                [_vShow, false]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_el_table, {
                    class: "mb-7 w-100",
                    ref: "multipleTableRef",
                    data: _ctx.formData.items,
                    "table-layout": "auto",
                    "row-class-name": "align-middle",
                    onSelect: _ctx.handleSelectChange,
                    onSelectionChange: _ctx.handleSelectionChange
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        type: "selection",
                        width: "50",
                        selectable: _ctx.isSelectable
                      }, null, 8, ["selectable"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('order.guid'),
                        prop: "guid"
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('order.article')
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_product_info, {
                            gallery: [
                          {
                            id: 0,
                            origin_url: row.image,
                          },
                        ],
                            name: row.name,
                            name_en: row.name_en,
                            source_link: '',
                            brand_id: row.brand
                          }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, { label: "" }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_sku_info, {
                            brand_article_no: row.brand_article_no,
                            color: row.original_color,
                            size: row.size,
                            product_identifier_id: '0'
                          }, null, 8, ["brand_article_no", "color", "size"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('common.status')
                      }, {
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.status === 0
                          ? _ctx.t("orderAssign.available")
                          : _ctx.t("orderAssign.notAvailable")), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_table_column, {
                        label: _ctx.t('orderAssign.stage')
                      }, {
                        default: _withCtx(({ row }) => [
                          _createVNode(_component_order_tracking_icon, {
                            value: row.stage.key,
                            node: row.stage.node
                          }, null, 8, ["value", "node"])
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["data", "onSelect", "onSelectionChange"])
                ])
              ])), [
                [_directive_loading, _ctx.loading]
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-lg btn-primary",
                  disabled: _ctx.isDisabledSubmit,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                }, [
                  _createElementVNode("span", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
                  ]),
                  _createElementVNode("span", _hoisted_16, [
                    _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                    _hoisted_17
                  ])
                ], 8, _hoisted_13)
              ])
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ])
    ])
  ], 512))
}